
<script>
import MdClose from 'svelte-icons/md/MdClose.svelte';
export let key;
export let closeDisclaimer;
export let disclaimers
export let storeId
</script>
<style>
.disclaimer-card {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255);
  height: 100%;
  width: 100%;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  /* padding: 1rem; */
}

.disclaimer-content {
  flex: 1 0 auto;
  padding: 0 1.5rem;
}
.disclaimer-close-top {
  margin-left: auto;
  margin-right: 1rem;
  margin-top: .5rem;
  max-width: 60px;

}
.disclaimer-close-top button {
  border: none;
  background: none;
  font-size: 22px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: none;
  background: white;
  color: black;
  padding: 16px;
}
.disclaimer-close {
  margin: 0 auto 1.5rem;
}
.disclaimer__list {
  font-size: .8rem;
}
</style>

<div class="disclaimer-card">
  <div class="disclaimer-close-top">
    <button on:click={() => closeDisclaimer(key)}><MdClose /></button>
  </div>
  <div class="disclaimer-content">
    <div>
      <h4>Offer Details</h4>
    </div>
    <ol class="disclaimer__list">
      {#each disclaimers as disclaimer}
        <li>{disclaimer.disclaimer}</li>
      {/each}
    </ol>
    {#if storeId === 'mazda'}

      <p>Offers not to be combined with any other offers. All offers with approved credit. Rebates may not be applicable to special rate financing offers from Mazda Finanncial Services. See dealer for complete details.
      </p>

    {/if}

  </div>
  <div class="disclaimer-close">
    <button on:click={() => closeDisclaimer(key)}>Close</button>
  </div>
</div>